angular.module('bmsApp.merrymaids')
	.factory('MMScheduleDataSvc', function (CRUDSvc) {

		return {
			load: function (params) {
				return CRUDSvc.get('api/merrymaids/schedule/load', params);
			},
			save: function (params) {
				return CRUDSvc.post('api/merrymaids/schedule/save', params);
			},
			confirmDay: function (params) {
				return CRUDSvc.post('api/merrymaids/schedule/confirm-day', params);
			},
			dayInfoActual: function (params) {
				return CRUDSvc.get('api/merrymaids/schedule/day-info-actual', params);
			},
			preInvoice: function (params) {
				return CRUDSvc.post('api/merrymaids/schedule/pre-invoice', params);
			},
			jobPartHistory: function (params) {
				return CRUDSvc.get('api/merrymaids/schedule/job-part-history', params);
			},
		};

	});
